import { render } from "./TemplateBOK.vue?vue&type=template&id=7a619d58&scoped=true"
import script from "./TemplateBOK.vue?vue&type=script&lang=js"
export * from "./TemplateBOK.vue?vue&type=script&lang=js"

import "./TemplateBOK.vue?vue&type=style&index=0&id=7a619d58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a619d58"

export default script